import React from 'react'
import ContactStyle from '../styles/ContactStyle'

const Contact = () => {
  return (
    <ContactStyle>
      <h5 className="phone phone-border">
        Masz pytanie? <span>885 885 000</span> napisz do nas lub skontaktuj się 
        <a href="mailto:sprzedaz@raks.pl">sprzedaz@raks.pl</a>
      </h5>
    </ContactStyle>
  )
}

export default Contact
